export const NotifySVG = (props) => (
  <svg height={65} viewBox="0 0 80 65" width={80} {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#1d1d1b"
      transform="translate(1 1)"
    >
      <path
        d="m38.2589253 25.9709967-6.8373028.7958422-8.8318254-3.4156826-3.7320526 1.7416122-3.6073601 9.9878283 2.36359 4.3744414s17.1663655 13.1287051 33.0887753 17.9800208h6.8417561s5.7109886-.9097724 10.0648334-5.8824407l.2597759-2.9493847-6.9683041-3.4735755"
        strokeWidth={1.5}
      />
      <path
        d="m50.7028425 57.4351147 3.0555217-7.3342171 7.1425396-4.9711838"
        strokeWidth={1.5}
      />
      <path
        d="m29.2838335 33.641234 2.3405812-2.1515015h3.0805716l18.5049538 15.8904945.5483128 2.7205964"
        strokeWidth={1.5}
      />
      <path
        d="m18.8578187 25.0926943 1.6994914 9.9878283 4.1074287 2.806508 4.6190019-4.2458523"
        strokeWidth={1.5}
      />
      <path d="m26.545276 17.405423 1.361597 8.002213" strokeWidth={1.3} />
      <path
        d="m38.8123223 26.4742013-.6492543 2.4096074 17.9725986 15.1004045 4.7652186 1.1454264"
        strokeWidth={1.5}
      />
      <path
        d="m38.6609537 25.5137553-8.0462324 5.6876445-.1686688 1.371617"
        strokeWidth={1.2}
      />
      <path d="m40.296756 28.883864-6.446525 4.467219" strokeWidth={1.2} />
      <path d="m43.158893 31.374726-6.446711 4.467219" strokeWidth={1.2} />
      <path d="m46.020864 33.865755-6.446526 4.467033" strokeWidth={1.2} />
      <path d="m48.883001 36.356598-6.446711 4.467218" strokeWidth={1.2} />
      <path d="m51.930506 38.847626-6.446525 4.467033" strokeWidth={1.2} />
      <path d="m54.792644 41.338469-6.446712 4.467219" strokeWidth={1.2} />
      <path
        d="m15.2503844 35.0805412h-.6607586l-1.390358 5.3126036 2.0511166 3.0965292s22.8166778 15.999786 33.7554717 18.6426351l8.5945015.2336128s10.2715409-1.5991065 12.4612665-7.8552535l-1.3740292-4.4098822-.8184798-1.4976083"
        strokeWidth={1.5}
      />
      <path
        d="m69.739372 53.4768715c3.0610884-1.1242732 6.7823788-3.1635143 8.000728-6.6448831l-1.3738436-4.4096966-.6927077-1.6376909"
        strokeWidth={1.5}
      />
      <path d="m29.283834 33.641234 23.119316 19.712541" strokeWidth={1.2} />
      <path
        d="m67.8691522 48.9804468c2.0529722-.78174 4.9585662-2.2951204 7.4273654-5.1149883l.260147-2.9495703-6.9683041-3.473761-22.6418857-19.1586614-6.8374884.7960277-8.832011-3.4156826-3.7316814 1.7416122-2.3693421 6.5593426"
        strokeWidth={1.5}
      />
      <path
        d="m60.467078 44.7625205.978613-2.3489312 7.1427252-4.9713693"
        strokeWidth={1.5}
      />
      <g strokeWidth={1.2}>
        <path d="m36.727008 26.1782979 2.5847707-2.3758365h3.080386l18.5051393 15.8904944.5484984 2.7205964" />
        <path d="m46.499779 18.7869301-.6494398 2.4094219 17.9725986 15.10059 4.7654041 1.1452408" />
        <path d="m45.8503392 18.28354-7.5483467 5.2304031-.1686689 1.371617" />
        <path d="m47.984213 21.196408-6.446711 4.467218" />
        <path d="m50.846165 23.687436-6.446712 4.467219" />
        <path d="m53.708302 26.178298-6.446711 4.467218" />
        <path d="m56.570272 28.669327-6.446711 4.467218" />
        <path d="m59.617963 31.16017-6.446711 4.467218" />
        <path d="m62.479915 33.651198-6.446711 4.467219" />
      </g>
      <path d="m0 24.158143 7.387515 1.294072" strokeWidth={1.5} />
      <path d="m10.664552 8.80636 5.303301 5.303301" strokeWidth={1.5} />
      <path
        d="m31.306553.014529.536065 7.480818"
        strokeWidth={1.4}
        transform="matrix(.99944948 -.03317731 .03317731 .99944948 -.107196 1.049627)"
      />
      <path d="m51.910496 2.988649-3.749962 6.495212" strokeWidth={1.5} />
      <path d="m66.99393 14.766278-6.737363 3.473376" strokeWidth={1.5} />
      <path d="m60.900885 45.129658-22.641885-19.158661" strokeWidth={1.2} />
    </g>
  </svg>
);
